import React, { useMemo } from 'react';
import Grid from '@mui/material/Grid';
import { Field } from 'formik';
import { fieldToSelect, Select } from 'app/components/FormikField/base';
import { DatePicker } from 'app/components/FormikField';
import { FormattedMessage } from 'react-intl';
import { Button, InputLabel, MenuItem, Select as MuiSelect } from '@mui/material';
import { useSelector } from 'react-redux';

const ConnectionRunForm = () => {
  const { selectedRow } = useSelector(state => state.ConnectionsReducer);
  const tenants = selectedRow?.packages[0].settings.tenants;
  let tagsControl = '';

  function CustomSelect(props) {
    const {
      form: { setFieldValue },
      field: { name },
    } = props;

    const onChange = React.useCallback(
      event => {
        const { value } = event.target;
        if (value.indexOf('controls') !== -1) {
          tagsControl && tagsControl === 'all' ? setFieldValue(name, tenants) : setFieldValue(name, []);
        } else {
          tagsControl = '';
          setFieldValue(name, value);
        }
      },
      [setFieldValue, name],
    );
    return <MuiSelect {...fieldToSelect(props)} onChange={onChange} />;
  }

  const datePicker = useMemo(() => {
    return {
      type: 'date',
      name: 'date',
      label: <FormattedMessage id="connections.date" />,
      required: true,
    };
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <DatePicker field={datePicker} />
      </Grid>
      <Grid item xs={12}>
        <InputLabel shrink htmlFor="tenants">
          {'Tenants:'}
        </InputLabel>
        <Field
          required
          color="secondary"
          component={CustomSelect}
          name="tenants"
          multiple
          value={tenants}
          label={<FormattedMessage id="connections.tenants" />}
          fullWidth
        >
          <MenuItem value="controls">
            <Button
              onClick={() => {
                tagsControl = 'all';
              }}
            >
              {'All'}
            </Button>
            <Button
              onClick={() => {
                tagsControl = 'reset';
              }}
            >
              {'Reset'}
            </Button>
          </MenuItem>
          {tenants
            .sort((a, b) => a.code.localeCompare(b.code))
            .map(option => (
              <MenuItem key={option.id} value={option}>
                {option.code}
              </MenuItem>
            ))}
        </Field>
      </Grid>
      <Grid item xs={12}>
        <InputLabel shrink htmlFor="extractionType">
          {'Select Extraction:'}
        </InputLabel>
        <Field
          required
          color="secondary"
          component={Select}
          name="extractionType"
          label={<FormattedMessage id="connections.extractionType" />}
          fullWidth
        >
          <MenuItem value="xeinadin_group_start_reports_extraction">{'Trial Balances'}</MenuItem>
          <MenuItem value="xeinadin_group_start_invoices_extraction">{'Invoices'}</MenuItem>
          <MenuItem value="xeinadin_group_start_contacts_extraction">{'Contacts'}</MenuItem>
        </Field>
      </Grid>
    </Grid>
  );
};

export default ConnectionRunForm;
